export default {
  title: 'CSV de Reservas',
  buttons: {
    generate: 'Gerar & transferir',
  },
  fields: {
    date_range: 'Intervalo de datas (opcional)',
  },
  errors: {
    invalid_date_range: 'Por favor, selecione um intervalo de datas válido',
  },
};
